import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-tools",
  "use": "icon-tools-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-tools\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h24v24H0z\" /><g stroke=\"currentColor\" stroke-width=\"1.5\" transform=\"translate(3.5 4.5)\"><rect width=\"7\" height=\"6\" rx=\"1\" /><rect width=\"7\" height=\"6\" x=\"10\" rx=\"1\" /><rect width=\"7\" height=\"6\" y=\"9\" rx=\"1\" /><rect width=\"7\" height=\"6\" x=\"10\" y=\"9\" rx=\"1\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol